import { authHttp } from '../http'
import * as routes from '../../routes/settings.routes'
import { errorHandler } from '../../../util/error.service'

export async function getGroups() {
  try {
    const response = await authHttp().get(routes.urlGroups)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function saveGroup({ id, name, actived }) {
  try {
    const response = id
      ? await authHttp().put(routes.urlGroup, { id, name, actived })
      : await authHttp().post(routes.urlGroup, { name, actived })
    const { group } = response.data
    return group
  } catch (error) {
    throw errorHandler(error)
  }
}
